export default __webpack_public_path__ + "static/aayushi1-6b3d04783509d10f6b99002cf0657f11.jpg";